import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function MedicationSearchProperties({ question }) {
  return <QuestionLabel question={question} />
}